/**
 * @generated SignedSource<<6581a6323a41f231df876bf8501735a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileElementPart_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly currentElementState?: {
      readonly element: {
        readonly " $fragmentSpreads": FragmentRefs<"FileElementDisplay_FileElementV2Fragment">;
      };
    } | null;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectContentElementContainer_ContentSubmissionFragment" | "SubmitDisplayElementButton_ContentSubmissionFragment">;
  readonly " $fragmentType": "FileElementPart_ContentSubmissionFragment";
};
export type FileElementPart_ContentSubmissionFragment$key = {
  readonly " $data"?: FileElementPart_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileElementPart_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileElementPart_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "currentElementState",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "element",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "FileElementDisplay_FileElementV2Fragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ActiveELearningContentSubmissionDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectContentElementContainer_ContentSubmissionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubmitDisplayElementButton_ContentSubmissionFragment"
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "a8963f32ad7677c72c4ecfd72986ac10";

export default node;
